export default "__VITE_ASSET__HAQu2hnq__"